import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';
import roadieArgocdPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';

// Standalone /argocd page — lists all Argo CD applications via the
// /argocd/api Backstage proxy, with a per-app detail page at /argocd/:name.
//
// Uses createFrontendPlugin (not createFrontendModule) so the route registers
// at the top level — same pattern as the argo-workflows plugin. No trailing
// /* needed; react-router's Routes inside ArgoCDRouter handles sub-paths.
//
// Roadie's alpha plugin is still included for entity-tab + entity-card
// extensions on catalog Component pages.
const argoCdPage = PageBlueprint.make({
  params: {
    path: '/argocd',
    loader: () =>
      import('./ArgoCDRouter').then(m => <m.ArgoCDRouter />),
  },
});

export const argocdPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'argocd-pages',
  extensions: [argoCdPage],
});

export const argocdFeatures: FrontendFeature[] = [
  roadieArgocdPlugin,
  argocdPlugin,
];
